module.exports = __webpack_public_path__ + "assets/img/2-m.a1bb5158.jpg";